import { Icon } from '@types-custom/models/ui/icon-model';
import { IModalParkingZoneModel } from './../../../../../types/src/lib/models/ui/modal-parking-zone-model';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'modal-parking-zone',
  templateUrl: './modal-parking-zone.component.html',
  styleUrls: ['./modal-parking-zone.component.scss'],
})
export class ModalParkingZoneComponent {
  @Input() properties: IModalParkingZoneModel;
  Icon = Icon
}
